<template>
  <div class="body">
    <header_index style="background-color: #fff;" v-if="!isMobile()"></header_index>
    <div class="box" v-if="!isMobile()">
      <div class="top1">
        <swiper class="t1box" :options="swiperOption" v-if="top1list && top1list.length > 0" ref="mySwiper">
          <swiper-slide v-for="(item, index) in top1list" :key="index" class="t1item">
            <img :src="item" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination" @click="swiperpagination()"></div>
        </swiper>
      </div>
      <div class="top2">
        <img class="laba" src="../../assets/img/icon/laba.png" alt="" />
        <vue-seamless-scroll :data="top2list" :class-option="classOption" class="t2right">
          <div class="t2rbox">
            <div class="t2item" v-for="(item, index) in top2list" :key="index" @click="clkNews(item, '读书节')">
              <div class="dian"></div>
              <div class="t2box">{{ item.title }}</div>
            </div>
          </div>
        </vue-seamless-scroll>
      </div>
      <div class="top3" style="display:none">
        <div class="boxtitle">
          <div class="btitle">
            <span>好书推荐</span>
          </div>
        </div>
        <div class="t3row">
          <el-alert title="征集已结束，平台将于8月11日开启投票通道，敬请期待 ！" type="info" :closable="false" effect="dark">
          </el-alert>
          <!-- <div class="t3box">
            <div class="t3top">
              <img src="https://cgp-resource.oss-cn-beijing.aliyuncs.com/Images/Reading/expert.jpg"
                   alt="" />
            </div>
            <div class="t3tip">
              <img src="../../assets/img/reading/tl2.png"
                   alt="" />
              <div class="t3tiptext">
                <span>专家推荐</span>
              </div>
            </div>
            <div class="t3bot">
              <div class="t3btext">
                <span>更多好书尽在全科阅读</span>
              </div>
              <div class="t3bbtn"
                   @click="toTuijian(1)">
                <span>我要推荐</span>
              </div>
            </div>
          </div>
          <div class="t3box">
            <div class="t3top">
              <img src="https://cgp-resource.oss-cn-beijing.aliyuncs.com/Images/Reading/reader.jpg"
                   alt="" />
            </div>
            <div class="t3tip">
              <img src="../../assets/img/reading/tl1.png"
                   alt="" />
              <div class="t3tiptext">
                <span>读者推荐</span>
              </div>
            </div>
            <div class="t3bot">
              <div class="t3btext">
                <span>更多好书尽在全科阅读</span>
              </div>
              <div class="t3bbtn"
                   @click="toTuijian(2)">
                <span>我要推荐</span>
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <div class="top3">
        <div class="boxtitle">
          <div class="btitle">
            <span>主编分享会</span>
          </div>
        </div>
        <div>
          <div class="t3row">
            <div class="t3box" v-for="(item, index) in livebacklist1" :key="index + 12" @click="toShipin(item)">
              <div class="t3top">
                <img :src="item.imageurl" alt="" />
              </div>
              <div class="t3bot">
                <div class="t3btext">
                  <!-- <img src="../../assets/img/icon/shizhong2.png" alt=""> -->
                  <span>{{ item.name }}</span>
                </div>
                <div class="t3bbtn">
                  <span>点击观看</span>
                </div>
              </div>
            </div>

          </div>
          <div class="t3row">
            <div class="t3box" v-for="(item, index) in livebacklist2" :key="index + 13" @click="toShipin(item)">
              <div class="t3top">
                <img :src="item.imageurl" alt="" />
              </div>
              <div class="t3bot">
                <div class="t3btext">
                  <!-- <img src="../../assets/img/icon/shizhong2.png" alt=""> -->
                  <span>{{ item.name }}</span>
                </div>
                <div class="t3bbtn">
                  <span>点击观看</span>
                </div>
              </div>
            </div>

          </div>
          <div class="t3row">
            <div class="t3box" v-for="(item, index) in livebacklist3" :key="index + 14" @click="toShipin(item)">
              <div class="t3top">
                <img :src="item.imageurl" alt="" />
              </div>
              <div class="t3bot">
                <div class="t3btext">
                  <!-- <img src="../../assets/img/icon/shizhong2.png" alt=""> -->
                  <span>{{ item.name }}</span>
                </div>
                <div class="t3bbtn">
                  <span>点击观看</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <Top4 />
      <Top5 class="development" />
      <Top6 class="development" />
      <Top7 class="development" />
      <Top8 class="development" />
    </div>
    <div class="mbox" v-else v-loading="true"></div>
    <footer_index v-if="!isMobile()"></footer_index>
    <el-dialog :visible.sync="isShipin" :title="shipinTitle" :before-close="shipinClose" width="700px">
      <div id="shipin"></div>
    </el-dialog>
  </div>
</template>

<script>
import header_index from '../home/header_index';
import footer_index from '../home/footer_index';
import vueSeamlessScroll from 'vue-seamless-scroll';
import Player from 'xgplayer';
import Top4 from './components/top4.vue';
import Top5 from './components/top5.vue';
import Top6 from './components/top6.vue';
import Top7 from './components/top7.vue';
import Top8 from './components/top8.vue';
export default {
    components: {
        header_index,
        footer_index,
        vueSeamlessScroll,
        Top4,
        Top5,
        Top6,
        Top7,
        Top8,
    },
    data() {
        return {
            player: null,
            isShipin: false,
            shipinTitle: '',
            top1list: ['https://cgp-resource.oss-cn-beijing.aliyuncs.com/train_resources/images/20230112/42f63685c58d262dd190dc4abef972fa.jpg'], //['https://cgp-resource.oss-cn-beijing.aliyuncs.com/Images/Reading/pc_rotation.jpg'],
            swiperOption: {
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    bulletClass: 'bulletWrite',
                    bulletActiveClass: 'bulletWriteActive',
                    clickable: true,
                },
                autoplay: {
                    delay: 15000,
                    disableOnInteraction: false,
                },
            },
            top2list: [],
            classOption: {
                limitMoveNum: 5,
                direction: 2,
            },
            istest: true,
            livebacklist1: [
                {
                    name: '好书推荐',
                    imageurl: 'https://cgp-resource.oss-cn-beijing.aliyuncs.com/train_resources/images/20230113/ffcd54d5c461a4c6a4e38b6398d89ed8.jpg',
                    videourl: 'https://cgp-resource.oss-cn-beijing.aliyuncs.com/train_resources/video/20230112/7ec66c4ab0e99863818ae13d3683e110.mp4',
                },
                {
                    name: '《全科医生临床实践》',
                    imageurl: 'https://cgp-resource.oss-cn-beijing.aliyuncs.com/train_resources/images/20230112/066ef31a8c11d50384aea50e8dcfd8b4.jpg',
                    videourl: 'https://cgp-resource.oss-cn-beijing.aliyuncs.com/train_resources/video/20230112/8a86346d2da6941b7dc9d3675036ffc5.mp4',
                },
            ],
            livebacklist2: [
                {
                    name: '《常见慢性疾病社区临床路径》',
                    imageurl: 'https://cgp-resource.oss-cn-beijing.aliyuncs.com/train_resources/images/20230112/38914e0b3a71236f91c04635fcf72de0.jpg',
                    videourl: 'https://cgp-resource.oss-cn-beijing.aliyuncs.com/train_resources/video/20230112/21f877e256e8414252346e50d65c580a.mp4',
                },
                {
                    name: '《全科医学诊断精要》',
                    imageurl: 'https://cgp-resource.oss-cn-beijing.aliyuncs.com/train_resources/images/20230112/a862fa42cf99502f8b0904a3af77abab.jpg',
                    videourl: 'https://cgp-resource.oss-cn-beijing.aliyuncs.com/train_resources/video/20230112/f40127bec7b60edda4f9afe0e29a5524.mp4',
                },
            ],
            livebacklist3: [
                {
                    name: '《赵氏百笑灸疗法》',
                    imageurl: 'https://cgp-resource.oss-cn-beijing.aliyuncs.com/train_resources/images/20230112/150301839659a97416205b44b961dc2e.jpg',
                    videourl: 'https://cgp-resource.oss-cn-beijing.aliyuncs.com/train_resources/video/20230112/60ca1d5eb55852a97a87f4eb4c38791e.mp4',
                },
                {
                    name: '《灵枢经讲解 针法探秘》',
                    imageurl: 'https://cgp-resource.oss-cn-beijing.aliyuncs.com/train_resources/images/20230112/858848187f135cf68497e8107f943278.jpg',
                    videourl: 'https://cgp-resource.oss-cn-beijing.aliyuncs.com/train_resources/video/20230112/8accb81a1fdc9e40b5c0710029f9d1c1.mp4',
                },
            ],
        };
    },
    created() {
        if (this.isMobile()) {
            window.location.href = this.httphelper.IsDebugH5GP519() + '/?name=reading';
        } else {
            // if (this.$route.query.type && this.$route.query.type == 'test') {
            //   this.istest = true
            // }
            this.getInfoList();
        }
    },
    methods: {
        /** @description 弹出视频 */
        toShipin(item) {
            if (this.$cookies.get('token_chinagp')) {
                this.shipinTitle = item.name;
                this.isShipin = true;
                var test1 = setTimeout(() => {
                    this.player = new Player({
                        id: 'shipin',
                        url: item.videourl,
                        autoplay: true,
                        playsinline: true,
                        width: '100%',
                        height: 'auto',
                    });
                    clearTimeout(test1);
                }, 100);
            } else {
                this.$alert('请先登录', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                        if (action == 'confirm') {
                            let callback = encodeURIComponent(window.location.href);
                            window.location.href = this.httphelper.IsDebugGP519() + '/loginIndex/login?callback=' + callback;
                            // window.location.href = 'http://localhost:8080/loginIndex/login?callback=' + callback;
                        }
                    },
                });
            }
        },
        /** @description 关闭弹出视频 */
        shipinClose() {
            if (this.player != null) {
                this.player.destroy();
                this.player = null;
            }
            this.isShipin = false;
        },
        isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
            return flag;
        },
        getInfoList() {
            this.httphelper
                .post('/api/NewApi/GetGpSiteNewInfoPageList', {
                    keyword: '',
                    id: 0,
                    parentID: 0,
                    column_Type: 218,
                    pageIndex: 1,
                    pageSize: 99,
                })
                .then(res => {
                    if (res.data.code == 200) {
                        this.top2list = res.data.data.gpSiteNewInfoViewsViews;
                    }
                });
        },
        clkNews(info, meuntitle) {
            //如果外连接存在，跳转外链，否则跳转详情
            if (Object.keys(info.address).length == 0) {
                var param = {
                    pid: 40,
                    title: meuntitle,
                    cid: info.cid,
                    goroutename: 'home/Inforlist',
                };
                localStorage.setItem('Inforlist_param_' + info.cid, JSON.stringify(param));
                const { href } = this.$router.resolve({
                    path: '/home/Inforlist/inforDetails?',
                    query: {
                        id: info.id,
                        column_Type: info.cid,
                    },
                });
                window.open(href, '_blank');
            } else {
                window.open(info.address);
            }
        },
        toTuijian(type) {
            if (type == 1) {
                this.$alert('专家推荐通道尚未开启，推荐图书请点击“读者推荐', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {},
                });
                // window.open('http://dshe.gp519.com/', "_blank")
            } else if (type == 2) {
                if (this.$cookies.get('token_chinagp')) {
                    window.open('http://dshr.gp519.com/?token=' + this.$cookies.get('token_chinagp'), '_blank');
                } else {
                    this.$alert('请先登录', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                            let callback = encodeURIComponent(window.location.href);
                            window.location.href = this.httphelper.IsDebugGP519() + '/loginIndex/login?callback=' + callback;
                        },
                    });
                }
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.body {
    height: 100%;
}

.box {
    min-height: calc(100vh - 384px);
    padding-bottom: 40px;

    .boxtitle {
        width: 100%;
        border-bottom: 1px solid #eee;
        margin: 20px 0;

        .btitle {
            display: inline-block;
            font-size: 26px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #000000;
            line-height: 26px;
            padding: 15px 0;
            border-bottom: 1px solid #000;
        }
    }

    .top1 {
        width: 100%;
        height: 440px;
        background: linear-gradient(180deg, #e0fbf6, #ffffff);
        overflow: hidden;

        .t1box {
            width: 1200px;
            margin: 35px auto 25px;

            .t1item {
                width: 1200px;
                height: 380px;
                border-radius: 20px 20px 20px 20px;
                overflow: hidden;
                background-color: #eee;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .swiper-pagination {
            text-align: left;
            box-sizing: border-box;
            padding-left: 20px;
        }
    }

    .top2 {
        width: 1200px;
        margin: 0 auto;
        height: 50px;
        display: flex;
        align-items: center;

        .laba {
            margin-right: 20px;
        }

        .t2right {
            width: 1159px;
            height: 40px;
            line-height: 40px;
            overflow: hidden;

            .t2rbox {
                display: flex;
                // width: 1500px;
            }

            .t2item {
                // width: 260px;
                margin-right: 40px;
                display: flex;
                align-items: center;

                .dian {
                    width: 10px;
                    height: 10px;
                    background: #cecece;
                    border-radius: 50%;
                    margin-right: 10px;
                }

                .t2box {
                    // width: 300px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    cursor: pointer;
                }
            }

            .t2item:hover {
                color: #0b8586;

                .dian {
                    background: #0b8586 !important;
                }
            }
        }
    }

    .top3 {
        width: 1200px;
        margin: 0 auto;

        .t3row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 30px;

            .t3box {
                width: 585px;
                height: 354px;
                background: #ffffff;
                box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
                border-radius: 0px 0px 5px 5px;
                position: relative;

                .t3top {
                    width: 100%;
                    height: 280px;

                    img {
                        width: 100%;
                        height: 280px;
                    }
                }

                .t3tip {
                    position: absolute;
                    top: 0;
                    left: 0;

                    .t3tiptext {
                        width: 120px;
                        position: absolute;
                        font-size: 20px;
                        font-family: Microsoft YaHei;
                        font-weight: bold;
                        color: #ffffff;
                        line-height: 40px;
                        top: 26px;
                        left: -16px;
                        transform: rotate(-46deg);
                        text-align: center;
                    }
                }

                .t3bot {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 74px;
                    padding: 0 20px;

                    .t3btext {
                        display: flex;
                        align-items: center;
                        font-size: 16px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #7a7a7a;
                        line-height: 28px;

                        img {
                            margin-right: 10px;
                        }
                    }

                    .t3bbtn {
                        width: 138px;
                        height: 34px;
                        line-height: 34px;
                        text-align: center;
                        background: #def3f3;
                        color: #0b8586;
                        border: 1px solid #0b8586;
                        border-radius: 17px;
                        cursor: pointer;
                    }
                }
            }

            .t3box:hover {
                position: relative;
                box-shadow: 7px 19px 30px 0px rgba(11, 133, 134, 0.25);

                .t3bbtn {
                    background: #0b8586;
                    color: #fff;
                    border: 1px solid #0b8586;
                }
            }

            ::v-deep .el-alert__title {
                font-size: 16px;
                line-height: 30px;
            }
        }
    }
}

.mbox {
    padding: 20px 3vw;
    background-color: #e5f2ff;
    min-height: 100%;
    box-sizing: border-box;
}

.development {
    display: none;
}
</style>
